/**
 * @generated SignedSource<<34e604948bd946dc8db8be1a5e5d88da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceRendererStepThruNote_note$data = {
  readonly bulb_id: string;
  readonly note_duration: number;
  readonly note_start: number;
  readonly midi_number: number;
  readonly " $fragmentType": "PieceRendererStepThruNote_note";
};
export type PieceRendererStepThruNote_note$key = {
  readonly " $data"?: PieceRendererStepThruNote_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRendererStepThruNote_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceRendererStepThruNote_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulb_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_duration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "midi_number",
      "storageKey": null
    }
  ],
  "type": "MusicPieceFileNote",
  "abstractKey": null
};

(node as any).hash = "015013cd0380ffcb16d5179d772d3200";

export default node;
